var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 107,
    viewBox: "0 0 72 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5706"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 276",
    cx: 36.1261,
    cy: 25.9766,
    r: 24.4766,
    stroke: "#172B02",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1873",
    d: "M70.2523 106L64.6364 62.6326C63.8432 56.5074 57.7419 52.5586 51.8291 54.3436L41.9063 57.3392C38.1369 58.4771 34.1155 58.4771 30.3461 57.3392L20.4232 54.3436C14.5104 52.5586 8.40918 56.5074 7.61597 62.6326L2 106",
    stroke: "#172B02",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourAccount);
export default __webpack_public_path__ + "static/media/your-account.5737fba2.svg";
export { ForwardRef as ReactComponent };